import { Box, Container, Flex, Heading, Text } from "@chakra-ui/react";
import MapBg from "../img/map-bg.png";
import React from "react";
import ButtonTheme from "./ButtonTheme";

const Map = ({ location, city }) => {
  const handleButtonClick = () => {
    window.location.href = "/search?address=" + location;
  };
  return (
    <Box h={{ md: "100vh", base: "70vh" }} bgImage={MapBg} bgSize={"cover"}>
      <Container maxW={"90%"} h={"100%"}>
        <Flex
          alignItems={"center"}
          justifyContent={"center"}
          textAlign={"center"}
          flexDir={"column"}
          h={"100%"}
        >
          {location && (
            <Box w={"100%"}>
              <Text fontSize={{ md: "2xl", base: "lg" }} color={"white"}>
                Search Properties Around
              </Text>
              <Heading fontSize={{ md: "8xl", base: "5xl" }} color={"white"}>
                {city}
              </Heading>
            </Box>
          )}
          <ButtonTheme
            btnText={"Open up the map"}
            handleButtonClick={handleButtonClick}
          />
        </Flex>
      </Container>
    </Box>
  );
};

export default Map;
